import React, { useEffect, useState } from 'react';
import {
  Form,
  Select,
  InputNumber,
  Button,
  Table,
  message,
  Typography,
  Divider,
  Alert,
  Grid,
  Card
} from 'antd';
import axios from 'axios';
import { ShoppingCartOutlined } from '@ant-design/icons';

const { Option } = Select;
const { Title } = Typography;
const { useBreakpoint } = Grid;

const CrearPedido = () => {
       const screens = useBreakpoint();
    const isMobile = !screens.md; // md = 768px
  const [clientes, setClientes] = useState([]);
  const [clienteId, setClienteId] = useState(null);
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);

  const [productos, setProductos] = useState([]);
  const [productosSeleccionados, setProductosSeleccionados] = useState([]);
  const [pedido, setPedido] = useState([]);

  const [loading, setLoading] = useState(false);
  const [alerta, setAlerta] = useState(null);

  useEffect(() => {
    fetchClientes();
    fetchProductos();
  }, []);

  const fetchClientes = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get('https://elarigestion-production.up.railway.app/api/mis-clientes', {
        headers: { Authorization: token },
      });
      setClientes(res.data);
    } catch (error) {
      console.error('Error al obtener clientes:', error);
      message.error('No se pudieron cargar los clientes');
    }
  };

  const fetchProductos = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get('https://elarigestion-production.up.railway.app/api/mis-productos', {
        headers: { Authorization: token },
      });
      setProductos(res.data.productos);
    } catch (error) {
      console.error('Error al obtener productos:', error);
      message.error('No se pudieron cargar los productos');
    }
  };

  const actualizarCantidad = (productoId, cantidad) => {
    const actualizado = pedido.map((p) =>
      p.productoId === productoId ? { ...p, cantidad } : p
    );
    setPedido(actualizado);
  };

  const actualizarPrecio = (productoId, precio) => {
    const actualizado = pedido.map((p) =>
      p.productoId === productoId ? { ...p, precio } : p
    );
    setPedido(actualizado);
  };

  const actualizarCampo = (productoId, campo, valor) => {
    const actualizado = pedido.map((p) =>
      p.productoId === productoId ? { ...p, [campo]: valor } : p
    );
    setPedido(actualizado);
  };

  const eliminarProducto = (productoId) => {
    setPedido((prev) => prev.filter((p) => p.productoId !== productoId));
    setProductosSeleccionados((prev) =>
      prev.filter(
        (val) =>
          val !== String(productoId) &&
          val !== pedido.find((p) => p.productoId === productoId)?.nombre
      )
    );
  };

  const calcularTotal = () => {
    return pedido.reduce((sum, item) => sum + item.precio * item.cantidad, 0);
  };

  const enviarPedido = async () => {
    if (!clienteId) {
      setAlerta({ tipo: 'error', mensaje: 'Selecciona un cliente' });
      return;
    }

    if (pedido?.length === 0) {
      setAlerta({ tipo: 'error', mensaje: 'Agrega al menos un producto' });
      return;
    }

    try {
      setLoading(true);
      setAlerta(null);

      const token = localStorage.getItem('token');

      await axios.post(
        'https://elarigestion-production.up.railway.app/api/crear-pedido',
        {
          clienteId,
          productos: pedido.map((p) => ({
            productoId:
              typeof p.productoId === 'string' && p.productoId.startsWith('temp-')
                ? null
                : p.productoId,
            nombre: p.nombre,
            cantidad: p.cantidad,
            precio: p.precio,
            color: p.color || null,
            talle: p.talle || null,
          }))
        },
        {
          headers: { Authorization: token },
        }
      );

      setAlerta({ tipo: 'success', mensaje: 'Pedido creado exitosamente' });
      setPedido([]);
      setClienteId(null);
      setClienteSeleccionado(null);
      setProductosSeleccionados([]);
    } catch (error) {
      console.error(error);
      if (error.response) {
        setAlerta({
          tipo: 'error',
          mensaje: `Error del servidor: ${error.response.data?.mensaje || 'Intenta nuevamente.'}`,
        });
      } else if (error.request) {
        setAlerta({
          tipo: 'error',
          mensaje: 'No se pudo conectar al servidor. Verifica tu conexión.',
        });
      } else {
        setAlerta({
          tipo: 'error',
          mensaje: 'Error inesperado al crear el pedido.',
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '2rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '2rem' }}>
        <ShoppingCartOutlined style={{ fontSize: 32, color: '#1890ff' }} />
        <Title level={2} style={{ margin: 0 }}>Registrar Pedidos</Title>
      </div>

      <Form layout="vertical">
        <Form.Item label="Seleccionar Cliente">
          <Select
            showSearch
            placeholder="Selecciona un cliente"
            value={clienteId}
            onChange={(val) => {
              setClienteId(val);
              const cliente = clientes.find(c => c.id === val);
              setClienteSeleccionado(cliente);
            }}
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            style={{ width: '100%' }}
          >
            {clientes.map((cliente) => (
              <Option key={cliente.id} value={cliente.id}>
                {cliente.nombre_completo}
              </Option>
            ))}
          </Select>
        </Form.Item>

        {clienteSeleccionado && (
          <Alert
            message="Detalles del Cliente"
            description={
              <>
                <p><strong>Nombre:</strong> {clienteSeleccionado.nombre_completo}</p>
                <p><strong>Correo electrónico:</strong> {clienteSeleccionado.correo_electronico}</p>
                <p><strong>Teléfono:</strong> {clienteSeleccionado.celular}</p>
              </>
            }
            type="info"
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}

        <Form.Item label="Agregar Productos" name="productos">
          <Select
            mode="tags"
            placeholder="Selecciona o escribe productos"
            value={productosSeleccionados}
            onChange={(values) => {
              setProductosSeleccionados(values);

              values.forEach((val) => {
                const yaExiste = pedido.some(
                  (p) => String(p.productoId) === val || p.nombre === val
                );
                if (!yaExiste) {
                  const producto = productos.find((p) => String(p.id) === val);
                  if (producto) {
                    setPedido((prev) => [
                      ...prev,
                      {
                        productoId: producto.id,
                        nombre: producto.nombre,
                        precio: producto.precio,
                        cantidad: 1,
                        color: '',
                        talle: '',
                        coloresDisponibles: producto.colores.map(c => c.nombre),
                        tallesDisponibles: producto.talles.map(t => t.nombre),
                      },
                    ]);
                  } else {
                    const tempId = `temp-${Date.now()}-${Math.random()}`;
                    setPedido((prev) => [
                      ...prev,
                      {
                        productoId: tempId,
                        nombre: val,
                        precio: 0,
                        cantidad: 1,
                        color: '',
                        talle: '',
                        coloresDisponibles: [],
                        tallesDisponibles: [],
                      },
                    ]);
                  }
                }
              });

              setPedido((prev) =>
                prev.filter((p) =>
                  values.includes(String(p.productoId)) || values.includes(p.nombre)
                )
              );
            }}
            style={{ width: '100%' }}
            showSearch
            filterOption={(input, option) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
          >
            {productos.map((producto) => (
              <Option key={producto.id} value={String(producto.id)}>
                {producto.nombre} - ${producto.precio}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Form>

      <Divider>Productos Seleccionados</Divider>
{!isMobile ? (

      <Table dataSource={pedido} rowKey="productoId" pagination={false} bordered size="small" scroll={{ x: 'max-content' }}>
        <Table.Column title="Nombre" dataIndex="nombre" />

        <Table.Column title="Cantidad" dataIndex="cantidad" render={(cantidad, record) => (
          <InputNumber min={1} value={cantidad} onChange={(val) => actualizarCantidad(record.productoId, val)} />
        )} />

        <Table.Column title="Precio Unitario" dataIndex="precio" render={(precio, record) => (
          <InputNumber min={0} value={precio} onChange={(val) => actualizarPrecio(record.productoId, val)} />
        )} />

        <Table.Column title="Color" dataIndex="color" render={(color, record) => (
          <Select
            value={color}
            onChange={(val) => actualizarCampo(record.productoId, 'color', val)}
            placeholder="Color"
            style={{ width: 120 }}
            disabled={record.coloresDisponibles.length === 0}
          >
            {record.coloresDisponibles.map((color) => (
              <Option key={color} value={color}>{color}</Option>
            ))}
          </Select>
        )} />

        <Table.Column title="Talle" dataIndex="talle" render={(talle, record) => (
          <Select
            value={talle}
            onChange={(val) => actualizarCampo(record.productoId, 'talle', val)}
            placeholder="Talle"
            style={{ width: 120 }}
            disabled={record.tallesDisponibles.length === 0}
          >
            {record.tallesDisponibles.map((talle) => (
              <Option key={talle} value={talle}>{talle}</Option>
            ))}
          </Select>
        )} />

        <Table.Column title="Subtotal" render={(text, record) => `$${(record.cantidad * record.precio).toFixed(2)}`} />

        <Table.Column title="Acción" render={(text, record) => (
          <Button danger onClick={() => eliminarProducto(record.productoId)}>Eliminar</Button>
        )} />
      </Table>
): (
   <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
    {pedido.map((record) => (
      <Card
        key={record.productoId}
        title={record.nombre}
        extra={
          <Button danger size="small" onClick={() => eliminarProducto(record.productoId)}>
            Eliminar
          </Button>
        }
      >
        <p><strong>Cantidad:</strong></p>
        <InputNumber
          min={1}
          value={record.cantidad}
          onChange={(val) => actualizarCantidad(record.productoId, val)}
          style={{ marginBottom: 8 }}
        />

        <p><strong>Precio:</strong></p>
        <InputNumber
          min={0}
          value={record.precio}
          onChange={(val) => actualizarPrecio(record.productoId, val)}
          style={{ marginBottom: 8 }}
        />

        <p><strong>Color:</strong></p>
        <Select
          value={record.color}
          onChange={(val) => actualizarCampo(record.productoId, 'color', val)}
          placeholder="Color"
          style={{ width: '100%', marginBottom: 8 }}
          disabled={record.coloresDisponibles.length === 0}
        >
          {record.coloresDisponibles.map((color) => (
            <Option key={color} value={color}>{color}</Option>
          ))}
        </Select>

        <p><strong>Talle:</strong></p>
        <Select
          value={record.talle}
          onChange={(val) => actualizarCampo(record.productoId, 'talle', val)}
          placeholder="Talle"
          style={{ width: '100%' }}
          disabled={record.tallesDisponibles.length === 0}
        >
          {record.tallesDisponibles.map((talle) => (
            <Option key={talle} value={talle}>{talle}</Option>
          ))}
        </Select>

        <div style={{ marginTop: 10 }}>
          <strong>Subtotal:</strong> ${ (record.precio * record.cantidad).toFixed(2) }
        </div>
      </Card>
    ))}
  </div>
)}


      <Divider />

      {alerta && (
        <Alert
          message={alerta.mensaje}
          type={alerta.tipo}
          showIcon
          closable
          onClose={() => setAlerta(null)}
          style={{ marginBottom: 16 }}
        />
      )}

      <div style={{ textAlign: 'right', marginTop: 16 }}>
        <Title level={4}>Total: ${calcularTotal().toFixed(2)}</Title>
        <Button type="primary" onClick={enviarPedido} loading={loading}>Crear Pedido</Button>
      </div>
    </div>
  );
};

export default CrearPedido;
